import React from 'react';
import PropTypes from 'prop-types';

// Helpers
import classNames from 'classnames';

// Styles
import styles from './styles/NavTab.scss';

const NavTab = props => {
    const tabClasses = classNames(styles.label, {
        [styles.isSelected]: props.isSelected,
    });

    return (
        <div
            data-tn={`tab-${props.linkCopy.toLowerCase()}`}
            className={tabClasses}
            onClick={props.onClick}
        >
            {props.linkCopy}
        </div>
    );
};

NavTab.defaultProps = {
    isSelected: false,
};

NavTab.propTypes = {
    isSelected: PropTypes.bool,
    linkCopy: PropTypes.string,
    linkTo: PropTypes.string,
    onClick: PropTypes.func,
};

export default NavTab;
